import ShareableLinksTable from './ShareableLinksTable.component';

export default ShareableLinksTable;